export const isDevelopment = () => {
  const isDevelopment =
    window.location.href.includes('localhost') ||
    window.location.href.includes('127.0.0.1');
  return isDevelopment;
};

export const isStaging = () => {
  const isStaging = window.location.href.includes('staging');
  return isStaging;
};

export const isProduction = () => {
  const isDev = isDevelopment();
  const isStaging = window.location.href.includes('staging');
  return !isDev && !isStaging;
};
